import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-redirect-dialog',
  templateUrl: './redirect-dialog.component.html',
  styleUrls: ['./redirect-dialog.component.scss']
})
export class RedirectDialogComponent {

  text: string;
  routerlink: string;
  reset_event: boolean;
  icon_class: string;
  routerLinkText: string;
  resetButt: any;
  ng_class: any;
  custom_dialog_box: any;
  dialog_button_box: any;
  warningDialog: any;
  marRight: any;
  small_font: boolean = false;
  has_priv: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.text = data.text;
    this.routerlink = data.routerlink;
    this.icon_class = data.icon_class;
    this.routerLinkText = data.routerLinkText;
    this.resetButt = data.resetButt;
    this.ng_class = data.ng_class;
    this.custom_dialog_box = data.custom_dialog_box;
    this.dialog_button_box = data.dialog_button_box;
    this.warningDialog = data.warningDialog;
    this.marRight = data.marRight;
    this.small_font = data.small_font;

  }
}

